import { SvgImage } from "@components/svgImage/SvgImage";
import { withTheme } from "@hoc/withTheme";
import React from "react";

import { PropsWithTheme, Theme } from "../../theme";
import { DashboardBackgroundStyled } from "./NavDashboard.styles";

export enum BackgroundType {
    WelcomeScreen,
    ConnectWithIDoklad,
    GoodbyeScreen
}

interface IProps {
    type?: BackgroundType;
    isOverContent?: boolean;
    isTransparent?: boolean;
    hasShellBar?: boolean;
}

function getBackgroundImageNameFromType(type: BackgroundType): keyof Theme {
    switch (type) {
        case BackgroundType.WelcomeScreen:
            return "F_wave_mountain";
        case BackgroundType.ConnectWithIDoklad:
            return "F_wave_mountain_panorama";
        case BackgroundType.GoodbyeScreen:
            return "F_wave_mountain_complex";
        default:
            return "F_wave";
    }
}

const DashboardBackground: React.FC<IProps & PropsWithTheme> = ({ type, isTransparent, isOverContent, hasShellBar, theme }) => {
    // todo image maps to prevent click on specific area, disabled when not on foreground
    return (
        <DashboardBackgroundStyled
            className="dashboard-background"
            $type={getBackgroundImageNameFromType(type)}
            $hasShellBar={hasShellBar !== false}
            $isTransparent={isTransparent}
            $isBehindContent={!isOverContent}>
            <SvgImage src={theme.F_wave}/>
        </DashboardBackgroundStyled>
    );
};

export default withTheme(DashboardBackground);